export const ORG_POST = 'ORG_POST'
export const ORG_UPDATE = 'ORG_UPDATE'
export const ORG_ERROR = 'ORG_ERROR'

export function addOrg(payload = {}) {
  return {
    type: ORG_POST,
    payload,
  }
}

export function updateOrg(payload = {}) {
  return {
    type: ORG_UPDATE,
    payload,
  }
}

export function errorOrg(payload = {}) {
  return {
    type: ORG_ERROR,
    payload,
  }
}
